import React from 'react'
import { View, Image, StyleSheet } from 'react-native'
import { HeaderBackButton } from '@react-navigation/elements'
import { createStackNavigator } from '@react-navigation/stack'

import { useContent } from '@sart/content'
import { Text } from '@sart/components'
import { theme, colors } from '@sart/styles'

import { stackNavigationProps } from '../nagivationProps'
import { CheckoutNavigationStacks } from '../Checkout'
import { CompanyIcon } from '@sart/icons'

import Shopping from './Shopping'
import GroupedAddons from './GroupedAddons'
import PurchaseAddonReview from './PurchaseAddOnReview'
import Confirmation from '../Confirmation'
import HostedPayment from '../HostedPayment'

const Stack = createStackNavigator()

function AddonsStackNavigator() {

  const content = useContent()

  return (
    <Stack.Navigator
      initialRouteName='Shopping'
      screenOptions={{
        ...stackNavigationProps.screenOptions
      }}
    >
      <Stack.Screen
        name="Shopping"
        component={Shopping}
        options={({ navigation }) => ({
          title: content.navigation.shopping,
          headerTitleStyle: theme.navigationHeader,
          headerShadowVisible: false,
          headerLeft: () => (<View style={{ paddingLeft: 15 }}>
            <Image
              source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
              style={styles.logoImage}
            />
          </View>)
        })}
      />
      <Stack.Screen
        name="AddOns"
        component={Shopping}
        options={({ navigation }) => ({
          title: content.navigation.shopping,
          headerTitleStyle: theme.navigationHeader,
          headerShadowVisible: false,
          headerLeft: () => (<View style={{ paddingLeft: 15 }}>
            <Image
              source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
              style={styles.logoImage}
            />
          </View>),
          headerStyle: {
            maxWidth: 600,
            backgroundColor: 'tomato'
          }
        })}
      />
      <Stack.Screen
        name="GroupedAddons"
        component={GroupedAddons}
        options={({ navigation }) => ({
          title: content.navigation.shopping,
          headerTitleStyle: theme.navigationHeader,
          headerShadowVisible: false,
          headerLeft: props => (
            <HeaderBackButton
              labelVisible={true}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Shopping')
              }}
            />
          )
        })}
      />
      <Stack.Screen
        name="PurchaseAddonReview"
        component={PurchaseAddonReview}
        options={({ navigation }) => ({
          title: 'Confirm Add On',
          headerCenter: () => <Text style={theme.navigationHeader}>{content.navigation.shopping}</Text>,
          headerTitleStyle: theme.navigationHeader,
          headerRight: () => (<View />),
          headerLeft: () => (
            <HeaderBackButton
              backTitleVisible={true}
              title={content.navigation.shopping}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Shopping')
              }}
              tintColor={colors.brightOrange}
            />
          )
        })}
      />
      <Stack.Screen
        name="Confirmation"
        component={Confirmation}
        options={({ navigation }) => ({
          title: '',
          headerRight: () => (<View />),
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              label={content.navigation.dashboard}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Shopping')
              }}
              tintColor={colors.white}
            />
          ),
        })}
      />
      <Stack.Screen
        name="HostedPayment"
        component={HostedPayment}
        options={({ navigation }) => ({
          title: '',
          headerRight: () => (<View />),
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              label={content.navigation.shopping}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Shopping')
              }}
              tintColor={colors.white}
            />
          ),
        })}
      />
      <Stack.Screen
        name="Checkout"
        component={CheckoutNavigationStacks}
        options={({ navigation }) => ({
          headerTitleStyle: theme.navigationHeader,
        })}
      />
    </Stack.Navigator>
  )
}

const styles = StyleSheet.create({
  logoImage: {
    height: 45,
    width: 45,
    position: 'relative'
  }
})

export default AddonsStackNavigator